<div class="container customer-search" pos-relative>
  
  <div class="row cc-panel">
    <div class="col-md-12 col-lg-7">     
    <div class="row">
      <div class="col-md-12">
        <h6 class="section-heading">Customer Search</h6>
      </div>
    </div>
    <form [formGroup]="customerSearchForm" autocomplete="off" id="txtCustomerForm">
      <div class="row row-bottom-space">
          <div class="col-md-4" *ngIf="false">
            <app-alight-drop-down [group]="customerSearchForm" [controlName]="'clientId'" [required]="false" 
              description="clientName" [disable]="rootService.disableDropdown()" label="Client" [value]="'clientId'" [list]="
                rootService.liveChatCTS.length < 2
                  ? customerService.clients
                  : rootService.liveChatCTS
              ">
            </app-alight-drop-down>
          </div>
       
          <div class="col-md-6" >
        
            <app-alight-smart-search-drop-down  [group]="customerSearchForm" [controlName]="'clientName'" [required]="true" (changeEvent)="onClientChange($event)" (clearEvent)="onClearSelection($event)"
            description="clientName" [clearSeleAvailable]="!rootService.disableDropdown()" [disable]="rootService.disableDropdown()" label="Client" [value]="'clientName'"
            [list]="(rootService.liveChatCTS.length < 2 || !rootService.checkForUnsecuredChat())? customerService.clients: rootService.liveChatCTS" [required]="true">
          </app-alight-smart-search-drop-down>
          	         
          </div>
          <div class="col-md-6" *ngIf="rootService.isUDPIdSkillForCustomerSearch && !rootService.checkCallOrChat()">
            <mat-form-field appearance="fill" class="component-box">
              <mat-label>UDP ID</mat-label>
              <input  (input)="onUdpIdChange($event)" matInput formControlName="udpId" id="udpId" (focus)="onFocus($event)" />
              <mat-error *ngIf="customerSearchForm.get('udpId')?.hasError('invalidSpecialChar')">
                Special characters are not allowed.
              </mat-error>
            </mat-form-field>
          </div>


          <div class="col-md-4">
       
          </div>

        <div class="col-md-6" *ngIf="false">
          <app-alight-drop-down [group]="customerSearchForm" [controlName]="'customerType'" value="fieldValue"
            description="fieldValueDescription" label="Customer Type" [list]="customers"></app-alight-drop-down>
        </div>
      </div>

      <div class="row row-bottom-space">
        <div class="col-md-6">
          <mat-form-field appearance="fill" class="component-box" [ngClass]="{ 'error-border': invalid }">
            <mat-label>Last Name (Required)</mat-label>
            <input matInput formControlName="lastName" autocomplete="off" id="lastName" (focus)="onFocus($event)"
              (keyup)="onKeyUp($event, 'lastName')" />
            <mat-error *ngIf="
              errorHandling('lastName', 'required') ||
              errorHandling('lastName', 'pattern')
            ">
              <f-icon icon-config='{"iconName": "circle-xmark", "iconType": "solid", "iconSize": "s"}'></f-icon>
              {{ errorMsg.lastName }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <mat-form-field appearance="fill" class="component-box">
            <mat-label>First Name</mat-label>
            <input matInput formControlName="firstName" id="firstName" (focus)="onFocus($event)" />
          </mat-form-field>
        </div>
       
      </div>
      <div class="row row-bottom-space">
        <div class="col-md-6">
            <mat-form-field appearance="fill" class="component-box cp-datepicker">
              <mat-label>Date of Birth (MMM-DD-YYYY)</mat-label>
              <input matInput [matDatepicker]="picker1" [max]="maxDate" formControlName="dateOfBirth" 
              (focus)="onFocus($event)">
              <mat-datepicker-toggle (click)="onFocus($event)" matIconSuffix [for]="picker1"></mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
               <mat-error *ngIf="customerSearchForm.get('dateOfBirth')?.hasError('matDatepickerParse')">
                <f-icon icon-config='{"iconName": "circle-xmark", "iconType": "solid", "iconSize": "s"}'></f-icon>
                Invalid date format: {{ customerSearchForm.get('dateOfBirth')?.getError('matDatepickerParse').text }} 
              </mat-error>
            </mat-form-field>
           
        </div>
        <div class="col-md-6">
          <mat-form-field appearance="fill" class="component-box" [ngClass]="{ 'error-border': invalid }">
            <mat-label>National ID (Last 4)</mat-label>
            <input matInput formControlName="nationalId" maxlength="4" id="nationalId" (focus)="onFocus($event)"
              (keyup)="onKeyUp($event, 'nationalId')" />
            <mat-error *ngIf="
                errorHandling('nationalId', 'minlength') ||
                errorHandling('nationalId', 'pattern')
              ">
              <f-icon icon-config='{"iconName": "circle-xmark", "iconType": "solid", "iconSize": "s"}'></f-icon>
              {{ errorMsg.nationalId }}
            </mat-error>
          </mat-form-field>
        </div>

      </div>

      <div class="row">
        
        <div class="col-md-6">
          <mat-form-field appearance="fill" class="component-box error-border">
            <mat-label>Employee ID</mat-label>
            <input matInput formControlName="employeeId" id="employeeId" (focus)="onFocus($event)" />
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <mat-form-field appearance="fill" class="component-box">
            <mat-label>Postal Code</mat-label>
            <input matInput formControlName="postalCode" id="postalCode" (focus)="onFocus($event)" />
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="form-button-controls">
            <f-button text="Clear all" title="Clear all" type="button" variant="action" (buttonClicked)="clearAll()"></f-button>
            <f-button text="Search" title="Search" type="submit" variant="progressive" uuid="txtSearch" disabled="{{
             this.checkSearchDisable()
            }}" (buttonClicked)="submit()">
              </f-button>
            </div>
          </div>
        </div>
      </form>

    </div>
  <div class="col-md-12 col-lg-5"  >
    <f-data-card class="pos-relative clientInfo">
      <h5>Client Info</h5>
      <section class="error-wrapper" *ngIf="custAccService.checkDefaultPinLoadApiFail()" >
        <f-alert variant="error">
          <p> There was a problem loading the data. <button class="btn-alert" (click)="custAccService.getDefaultPin()">Try again</button> </p>
        </f-alert>
      </section>
      <section  class="error-wrapper" *ngIf="custAccService.checkCreateUpdateDefaultPinApiFail()">
        <f-alert variant="error">
          Unable to update default pin please try again on clicking of hollow pin icon
        </f-alert>
      </section>
      <section class="no-result" *ngIf="rootService.displayNoDataMsgOnClientInfoCard(clientId)">                 
          <p> No data available </p>                  
      </section>

      <app-carousel *ngIf="!rootService.displayNoDataMsgOnClientInfoCard(clientId)" [cardComponents]="rootService.clientInfoCard.clientInfoVSClientIdMap[clientId]"></app-carousel>
      
    
        
    </f-data-card>
  </div>
</div>
  <div class="row">
    <div class="col-md-4">
      <h6 class="search-result">Customer Search Results</h6>
    </div>
    <div class="col-md-8">
      <h6 class="display-result" *ngIf="totalRecords > 0 && totalRecords <= 50">

        Displaying
        <strong>{{ alightTable?.totalCount }}</strong> records
      </h6>
    </div>
  </div>
  <app-alight-table [dataSource]="dataSource" [totalRecords]="totalRecords" [gridColumns]="Columns" [rowPerPage]="10"
    (rowSelection)="rowSelection($event)" [disableButtons]="rootService.checkDuplicateCustomerSearchHavingLiveInteraction()"
    [hideReplaceAddButton]="false"></app-alight-table>

  <!-- Custom Dialog for CCR1-26 and CCR1-28 -->
  <div class="custom-overlay-container additional-account" *ngIf="isModalOpen">
    <div class="custom-overlay-body">
      <div class="custom-overlay-content" role="dialog">
        <app-additional-account-modal id="content" [activeChatCustomers]="activeChatCustomers" [data]="accountModal"
          (buttonClicked)="buttonEvent($event)"></app-additional-account-modal>
      </div>
    </div>
  </div>

  <app-custom-dialog *ngIf="rootService.customDialogData.displayCustomDialogCS" (actionOnClick)="buttonClick($event)">
  </app-custom-dialog>

  
  <app-loader *ngIf="rootService.custSearchLoader" [loaderType]="loaderType"
    [loaderMsg]="rootService.showCustSearchLoaderMsg"></app-loader>
</div>